import { resendActivationPath } from 'common/config/urls';
import { buildAuthSearchParams } from 'pages/Auth/utils';
import { RESEND_ACTIVATION_VIEW } from './ResendActivation.constants';
import type { BuildResendActivationUrlOptions } from './ResendActivation.types';

export const buildResendActivationUrl = ({
  email,
  returnTo,
  source,
  view = RESEND_ACTIVATION_VIEW.FORM,
}: BuildResendActivationUrlOptions = {}) => {
  const params = buildAuthSearchParams({
    email,
    returnTo,
    source,
    view: view ?? RESEND_ACTIVATION_VIEW.FORM,
  });

  return `${resendActivationPath}?${params.toString()}`;
};
